import { render, staticRenderFns } from "./ReportPaymentTypeTable.vue?vue&type=template&id=543a13b5&"
import script from "./ReportPaymentTypeTable.vue?vue&type=script&lang=js&"
export * from "./ReportPaymentTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports